<div *ngIf="isActive">
  <div *ngIf="isModeSelect" class="select is-small is-fullwidth">
    <select [formControl]="modeSelector" tabindex="0" data-ui-name="Mode Selector" data-ui-component="capture-filter-range" data-testid="capture-filter-range-mode-selector">
      <option *ngFor="let option of modeOptions" [value]="option.id" data-ui-name="Option caption" data-ui-component="capture-filter-range" data-testid="capture-filter-range-option-caption" [attr.data-entity-key]="option.id" data-entity-type="option">{{option.caption}}</option>
    </select>
  </div>
  <div [ngSwitch]="modeSelector.value">
    <div *ngSwitchCase="FilterSettingMode.VALUE">
      <div [ngSwitch]="dataType">
        <div *ngSwitchCase="FilterDataType.TEXT">
          <input class="input is-small is-fullwidth" type="text" [formControl]="value" tabindex="0" data-ui-name="Value" data-ui-component="capture-filter-range" data-testid="capture-filter-range-value">
        </div>
        <div *ngSwitchCase="FilterDataType.NUMBER">
          <input class="input is-small is-fullwidth" type="number" [formControl]="value" tabindex="0" data-ui-name="Value" data-ui-component="capture-filter-range" data-testid="capture-filter-range-value-value">
        </div>
      </div>
    </div>
    <div *ngSwitchCase="FilterSettingMode.RANGE">
      <input class="input is-small is-fullwidth" placeholder="Min" type="number" [formControl]="rangeFrom" tabindex="0" data-ui-name="Min" data-ui-component="capture-filter-range" data-testid="capture-filter-range-min">
      <input class="input is-small is-fullwidth" placeholder="Max" type="number" [formControl]="rangeTo" tabindex="0" data-ui-name="Max" data-ui-component="capture-filter-range" data-testid="capture-filter-range-max">
    </div>
    <div *ngSwitchCase="FilterSettingMode.LIST">
      <select [formControl]="selectedValue" data-ui-name="Selected Value" data-ui-component="capture-filter-range" data-testid="capture-filter-range-selected-value">
        <option *ngFor="let item of config.list" [value]="item.val" data-ui-name="Item val" data-ui-component="capture-filter-range" data-testid="capture-filter-range-item-val"><tra [slug]="item.display"></tra></option>
      </select>
    </div>
  </div>
</div>